import EntityValidationResult from 'modules/base/dto/validation/EntityValidationResult';
import nBossConnection from 'modules/base/service/nBossConnection';

class AdatlapService {
	constructor() {
		this.connection = nBossConnection.connection;
		this.CONTROL = 'vizsgazoAdatlapControl';
	}

	/**
	 * @param {string} packageName
	 * @param {string} paperType
	 * @param {number} examId
	 * @return {Promise<boolean>}
	 */
	createFolder(packageName, paperType, examId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/tesztlapControl/createFolder`, { packageName, paperType, examId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} packageName
	 * @param {string} paperType
	 * @param {number} examId
	 * @return {Promise<EntityValidationResult>}
	 */
	insertSheets(packageName, paperType, examId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/insertSheets`, { packageName, paperType, examId })
				.then(response => resolve(new EntityValidationResult().setup(response.data)))
				.catch(reject);
		});
	}

	/**
	 * @param {string} packageName
	 * @param {string} paperType
	 * @param {number} examId
	 * @return {Promise<boolean>}
	 */
	deleteFolder(packageName, paperType, examId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/${this.CONTROL}/deleteFolder`, { packageName, paperType, examId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}

	/**
	 * @param {string} packageName
	 * @param {string} paperType
	 * @param {number} examId
	 * @return {Promise<boolean>}
	 */
	closeFolder(packageName, paperType, examId) {
		return new Promise((resolve, reject) => {
			this.connection
				.post(`/tesztlapControl/closeFolder`, { packageName, paperType, examId })
				.then(response => resolve(response.data))
				.catch(reject);
		});
	}
}

export default new AdatlapService();
